import { isNil } from './maybe';

function toArray<TPValue>(value: TPValue | TPValue[]): TPValue[] {
  return isArray<TPValue>(value) ? value : [value];
}

function first<TPValue>(array: TPValue[]): TPValue {
  if (array.length === 0) {
    throw new Error('Array is empty');
  }

  return array[0];
}

function last<TPValue>(array: TPValue[]): TPValue {
  if (array.length === 0) {
    throw new Error('Array is empty');
  }

  return array[array.length - 1];
}

function isArray<TPValue>(value: unknown): value is TPValue[] {
  return Array.isArray(value);
}

function flatten<TPValue>(array: TPValue[] | TPValue[][]): TPValue[] {
  return ([] as TPValue[]).concat(...array);
}

function unique<TPValue>(array: TPValue[]): TPValue[] {
  return Array.from(new Set(array));
}

function filter<TPValue>(
  array: TPValue[],
  predicate?: (value: TPValue, index: number, array: TPValue[]) => boolean
): TPValue[] {
  return array.filter(predicate ?? ((v) => !isNil(v)));
}

function randomElement<TPValue>(array: TPValue[]): TPValue {
  return array[Math.floor(Math.random() * array.length)];
}

function randomIndex<TPValue>(array: TPValue[]): number {
  return Math.floor(Math.random() * array.length);
}

export { toArray, first, last, isArray, flatten, unique, filter, randomElement, randomIndex };
